import React, { useState, useRef, useEffect } from "react";

import "./TH.css";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { uploadAbacusFile, closeAlert } from "../Redux/THSlice";
import { getCurrentMonth } from "../Redux/BussinessPOCSlice";
import { Typography } from "@mui/material";
import { Alert } from "@mui/material";
function UploadAbacus() {
 const [file, setFile] = useState("");
 const [errorMessage, setErrorMessage] = useState("");
 const [loading, setLoading] = useState(false);

 const response = useSelector((state) => state.traininghost.responseMessage);
 const isUploaded = useSelector((state) => state.traininghost.isUploaded);
 const dispatch = useDispatch();

 const ref = useRef();
 const saveFile = (e) => {
  setErrorMessage("");

  setFile(e.target.files[0]);
 };

 const handleUpload = () => {
  if (!file) {
   setErrorMessage("Please select a file.");
   return;
  }
  const formData = new FormData();
  formData.append("file", file);
  dispatch(uploadAbacusFile(formData));
 };
 useEffect(() => {
  dispatch(getCurrentMonth());
 }, []);
 return (
  <div>
   <Box>
    {isUploaded ? (
     <Alert
      style={{
       maxWidth: "fit-content",
       position: "fixed",
       top: "100px",
       right: "0px",
       backgroundColor: isUploaded ? "#05f0a5" : "#ff3246",
       color: "white",
      }}
      onClose={() => {
       dispatch(closeAlert());
      }}
     >
      {response}
     </Alert>
    ) : null}

    <Stack sx={{ marginTop: "30px" }} spacing={2} direction={"row"} alignItems={"center"}>
     <input type="file" accept=".xlsx" ref={ref} id="file" onChange={saveFile} hidden />
     <label for="file" className="th-mainData">
      Select File
     </label>
     <span className="th-file_caption">
      {file.name != undefined && file.name != null ? file.name : "No File Selected"}
     </span>
     <Button
      className={
       loading === false
        ? "th-upload_button_modal_active"
        : "th-upload_button_modal_inactive"
      }
      sx={{ minWidth: "30px !important" }}
      onClick={handleUpload}
     >
      Upload
      {/* {loading === false ? "Upload" : "Cancel"} */}
     </Button>
    </Stack>
   </Box>
  </div>
 );
}

export default UploadAbacus;
